<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">{{ this.$route.name }}</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item active"><i v-bind:class="routeIcon"></i> {{ $t(this.$route.name) }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <section class="content">
      <AltenteFreespinsAddForm ref="addModal" :default-values="{}" @finish="handleItemsUpdate"/>
      <div class="container-fluid">
        <b-row class="col-lg-12">
          <div class="col-lg-12">
            <b-button type="button" variant="success" class="mb-1 mr-1" @click="$refs.addModal.showModal()">
              <i class="fas fa-plus"></i> Add
            </b-button>
          </div>
        </b-row>

        <b-row class="col-lg-12">
          <div class="col-lg-3 col-md-3 col-sm-12" v-for="({id, type, label, options, loaded, internalSearch, searchChange}) in filterInputs" v-bind:key="id">
            <b-form-group label-cols-lg="4" :label-for="id + '-filter-input'" :label="label" v-if="type === 'input'">
              <b-form-input :id="id + '-filter-input'" v-model="filters[id]" autocomplete="off" :placeholder="'Enter ' + label"/>
            </b-form-group>

            <b-form-group label-cols-lg="4" :label-for="id + '-filter-input'" :label="label" v-if="type === 'multiselect'">
              <multiselect v-model="filters[id]"
                           :disabled="!loaded"
                           :loading="!loaded"
                           :options="options"
                           label="label"
                           track-by="value"
                           :multiple="false"
                           :placeholder="'Select ' + label"
                           :internal-search="internalSearch"
                           @search-change="searchChange"
              />
            </b-form-group>
          </div>
        </b-row>

        <b-row class="col-lg-12">
          <div class="col-lg-12 col-md-12 col-sm-12 apply-clear">
            <FilterButtons
                :cancel="this.cancel"
                :loadFn="loadItems"
                :cancelFn="cancelRequest"
                :resetFn="clearFilters"
            />
          </div>
        </b-row>

        <div class="row col-12" id="loading-container">
          <div class="col-12 mb-10">
            <div class="mb-10">
              <div class="table-wrapper mb-10">
                <b-table
                    striped small hover show-empty no-local-sorting sort-icon-left
                    :busy="!!cancel" :items="items" :empty-text="emptyText" :fields="fields"
                >
                  <template #cell(referenceId)="{item}">
                    <small style="font-size: 60%">{{ item.referenceId }}</small>
                  </template>

                  <template #cell(gameId)="{item}">
                    {{ games.find((game) => game.value == item.gameId).label }}
                  </template>

                  <template #cell(actions)="{item}">
                    <span>
                    <b-button type="button" variant="success" class="mr-1 btn-xs" @click="$refs.addModal.showModal(item)">
                      <i class="fas fa-copy"></i> Copy
                    </b-button>
                    </span>
                    <RemoveForm v-if="!item.isCanceled" :object="item.referenceId"
                                message="Please confirm removing freespins with id "
                                :remove-handler="(modal) => {handleFreespinsRemove(modal, item)}"
                    ></RemoveForm>
                  </template>
                </b-table>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<style>
.table td {
  min-width: 50px !important;
}
</style>
<script>
import axios from "axios";
import {getRouteIcon, ROUTE_WAZDAN_FREESPINS} from "../../utils/routerIcons";
import FilterButtons from "../../components/FilterButtons";
import Multiselect from "vue-multiselect";
import RemoveForm from "../../components/remove-form/RemoveForm.vue";
import AltenteFreespinsAddForm from "../../components/AltenteFreespins/AltenteFreespinsAddForm";

function getDefaultSort() {
  return {
    column: 'username',
    order: 'ASC',
  };
}

function getDefaultFilters() {
  return {
    operatorId: null,
    playerId: null,
  };
}

export default {
  components: {
    RemoveForm,
    FilterButtons,
    Multiselect,
    AltenteFreespinsAddForm
  },
  data() {
    return {
      operatorOptions: [],
      games: [],
      filters: getDefaultFilters(),
      cancel: null,
      error: null,
      fields: [
        { key: 'referenceId', label: 'Reference ID', },
        { key: 'playerId', label: 'Player ID', },
        { key: 'rounds', label: 'Rounds', },
        { key: 'roundsLeft', label: 'Rounds Left', },
        { key: 'currencyCode', label: 'Currency', },
        { key: 'betAmount', label: 'Bet', },
        { key: 'gameId', label: 'Game ID', },
        { key: 'expireBy', label: 'Expire', },
        { key: 'isCanceled', label: 'Is Canceled' },
        { key: 'actions', label: 'Actions' },
      ],
      items: [],
      sorts: getDefaultSort(),
    }
  },
  computed: {
    filterInputs() {
      return [
        {id: 'operatorId', type: 'multiselect', label: 'Operator', options: this.operatorOptions, internalSearch: true, loaded: this.$store.getters['operatorsForSelect/loaded'], searchChange: () => {}},
        {id: 'playerId', type: 'input', label: 'Player ID', placeholder: ''},
      ];
    },
    emptyText() {
      if (this.cancel) {
        return 'Loading items..';
      }

      if (this.error?.response?.data?.message) {
        return this.error?.response?.data?.message;
      }

      if (this.error) {
        return this.error.message;
      }

      return 'There are no records to show';
    },
    routeIcon: () => getRouteIcon(ROUTE_WAZDAN_FREESPINS),
  },
  methods: {
    clearFilters() {
      this.filters = getDefaultFilters();
    },
    handleFreespinsRemove(modal, item) {
      this
        .$http({
          url: '/api/v1/altente-freespins/cancel',
          method: 'POST',
          data: {
            operatorId: item.operatorId,
            referenceId: item.referenceId,
          },
          headers: {'Content-Type': 'application/json'},
        })
        .then(() => {
          this.loadItems();
          modal.hideModal();
          this.$toastr.i('Success');
        })
        .catch((err) => {
          this.$toastr.e(JSON.stringify(err.response.data.message));

          throw err;
        });
    },
    handleItemsUpdate({playerId, operatorId}) {
      this.filters.playerId = playerId;
      this.filters.operatorId = operatorId;

      this.loadItems();
    },
    loadItems() {
      this.items = [];

      let self = this;

      const operatorId = this.filters.operatorId ? this.filters.operatorId.value : null;
      this
          .$http({
            url: '/api/v1/altente-freespins',
            params: {
              ...this.filters,
              operatorId: operatorId,
            },
            method: 'GET',
            cancelToken: new axios.CancelToken(c => {self.cancel = c})
          })
          .then(resp => {
            let {items} = resp.data;
            this.items = items.map((item) => {
              return {...item, operatorId}
            });
          })
          .catch((err) => {
            this.items = [];
            this.error = err;
          })
          .finally(() => {
            this.cancel = null;
          });
    },
    cancelRequest() {
      if (this.cancel) {
        this.cancel('this -> cancel previous request');
      }
    },
  },
  mounted() {
  },
  async beforeMount() {
    await this.$store.dispatch('operatorsForSelect/loadList').then(() => {
      this.operatorOptions = this.$store.getters['operatorsForSelect/list'].map(({label, value}) => {return { label, value }});
    });
    await this.$store.dispatch('providerGames/loadList').then(() => {
      this.games = this.$store.getters['providerGames/list']
        .filter(({providerId}) => providerId === 'altente')
        .map(({tableId, name}) => {return { label: tableId + ' ' + name, value: tableId }});
    });
  },
}
</script>
